import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface PromptHeaderProps {
  imageSrc: string;
  title: string;
  description: string;
}

export const PromptHeader = ({ imageSrc, title, description }: PromptHeaderProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex items-center justify-between mb-8">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="text-gray-600"
        >
          ← Back
        </Button>
      </div>
      
      <div className="mb-8">
        <img 
          src={imageSrc} 
          alt={title}
          className="w-full h-[300px] object-cover rounded-2xl"
        />
      </div>

      <div className="space-y-6 mb-8">
        <h1 className="text-4xl font-medium">{title}</h1>
        <p className="text-lg text-gray-600">{description}</p>
      </div>
    </>
  );
};